import { Icon, Text } from "@blockdaemon-internal/precision-ui";
import { Trans } from "@lingui/react/macro";
import { Box, Container, Stack, Title, useMantineColorScheme } from "@mantine/core";
import badgePurple from "../../assets/blockdeamon-badge-purple.svg";
import badgeWhite from "../../assets/blockdeamon-badge-white.svg";
import { getMutedTextColor } from "../utils/theme-colors";
import { NavigationButton } from "./navigation-button";

interface NotFoundPageProps {
  fullHeight?: boolean;
}

export function NotFoundPage({ fullHeight = false }: NotFoundPageProps) {
  const { colorScheme } = useMantineColorScheme();

  return (
    <Container
      h={fullHeight ? "100vh" : undefined}
      display="flex"
      style={{ alignItems: "center", justifyContent: "center" }}
      my={fullHeight ? "undefined" : "5rem"}
    >
      <Stack align="center" spacing="lg">
        <Stack align="center" spacing="xs" mb="lg">
          {fullHeight &&
            (colorScheme === "dark" ? (
              <Box
                component="img"
                src={badgeWhite}
                alt={<Trans>Blockdeamon Badge White</Trans>}
                w={50}
              />
            ) : (
              <Box
                component="img"
                src={badgePurple}
                alt={<Trans>Blockdeamon Badge Purple</Trans>}
                w={50}
              />
            ))}

          <Title order={1}>
            <Trans>Page Not Found</Trans>
          </Title>
          <Text
            size="lg"
            sx={(theme) => ({
              color: getMutedTextColor(theme),
            })}
          >
            <Trans>The page you're looking for doesn't exist.</Trans>
          </Text>
        </Stack>
        <NavigationButton to="/">
          <Box component={Icon} icon="arrow_back" mr="0.5rem" />
          <Trans>Go Back</Trans>
        </NavigationButton>
      </Stack>
    </Container>
  );
}
